var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 41,
    viewBox: "0 0 54 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0441 27.2139C47.4671 27.2139 53.4847 21.1963 53.4847 13.7733C53.4847 6.35026 47.4671 0.332703 40.0441 0.332703C32.6211 0.332703 26.6035 6.35026 26.6035 13.7733C26.6035 21.1963 32.6211 27.2139 40.0441 27.2139Z",
    fill: "url(#paint0_linear_1_369)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3327 20.038L28.2797 1.92807C26.1591 -0.199147 22.7222 -0.199147 20.6016 1.92807L2.54864 20.038C1.53107 21.0587 0.958252 22.4436 0.958252 23.8891V35.0534C0.958252 38.0622 3.38833 40.4999 6.38767 40.4999H42.4936C45.493 40.4999 47.9231 38.0622 47.9231 35.0534V23.8891C47.9231 22.4436 47.3502 21.0587 46.3327 20.038Z",
    fill: "url(#paint1_linear_1_369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9256 2.28107L45.9786 20.3909C46.9026 21.3179 47.4231 22.5758 47.4231 23.8891V35.0534C47.4231 37.7875 45.2154 39.9999 42.4936 39.9999H6.38767C3.66595 39.9999 1.45825 37.7875 1.45825 35.0534V23.8891C1.45825 22.5758 1.97867 21.3179 2.90275 20.3909L20.9558 2.28107C22.8809 0.349854 26.0004 0.349854 27.9256 2.28107Z",
    stroke: "url(#paint2_linear_1_369)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_369",
    x: -17.0417,
    y: -17.6673,
    width: 82.9648,
    height: 76.1673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_369",
    x1: 40.046,
    y1: 42.0063,
    x2: 40.046,
    y2: -10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_369",
    x1: 3.60969,
    y1: 38.2322,
    x2: 38.8105,
    y2: -2.92563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_369",
    x1: 4.27344,
    y1: 3.49174,
    x2: 37.1029,
    y2: 44.5344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.af799d53fb85fd41d52e86220ba265da.svg";
export { ForwardRef as ReactComponent };